export const CAR_STRUCTURE_TYPE = "רכב" as const;
export const CARS_PATH = "/cars";
export const CARS_BREADCRUMB = { ledger: "כרטסות", list: "רכבים" } as const;
export const CARS_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;